import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from './Components/logout/logout.component';
import { SettingsComponent } from './Settings/settings.component';
import { NewDataExplorerComponent } from './new-data-explorer/new-data-explorer.component';

const routes: Routes = [
  { path: '', redirectTo: 'new-data-explorer', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('./Components/home/home.module').then(m => m.HomeModule),
    data: { pageTitle: 'Home' },
  },
  {
    path: 'new-data-explorer',
    component: NewDataExplorerComponent,
    data: { pageTitle: 'New Data Explorer' },
  },
  {
    path: 'reports',
    loadChildren: () => import('./Reports/reports.module').then(m => m.ReportsModule),
    data: { pageTitle: 'True Data Reports' }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: { pageTitle: 'Logout' }
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: { pageTitle: 'Settings' },
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
    data: { pageTitle: 'Configuration' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
